module.exports = __webpack_public_path__ + "static/media/diet.47829379.svg";